import React, { useEffect, useRef, useState } from "react";
import AlertBox from "../component/AlertBox";
import {
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";
import DialogBox from "../component/DialogBox";
import ButtonCompo from "../component/ButtonCompo";
import InputField from "../component/InputField";
import SelectField from "../component/SelectField";
import { MdCloudUpload } from "react-icons/md";
import AccrodianBox from "../component/AccrodianBox";
import { IoDocumentText } from "react-icons/io5";
import { Link } from "react-router-dom";

function EmployeeTickets() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [ticketData, setTicketData] = useState([]);
  const [requestTo, setRequestTo] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [reload, setReload] = useState(false);
  const [priority, setPriority] = useState("Low");
  const [ticketType, setTicketType] = useState("");
  const [ticketFiles, setTicketFiles] = useState([]);
  const ticketFileRef = useRef(null);

  // fetch employee data
  async function getTickets() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/ticket/get/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTicketData(res.data?.data);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Ticket fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // raise a ticket
  async function raiseTicket() {
    if (
      subject?.length === 0 ||
      requestTo?.length === 0 ||
      body === null ||
      ticketType.length === 0 ||
      priority.length === 0
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields and choose a file");
      return null;
    }
    if (Array.from(ticketFiles).length > 5) {
      setOpen(true);
      setSuccess(false);
      setMessage("Maximum 5 files can be uploaded");
      return null;
    }
    const formData = new FormData();
    Array.from(ticketFiles).map((file, i) => {
      formData.append("ticketFile", file);
    });
    formData.append("requestTo", requestTo);
    formData.append("subject", subject);
    formData.append("body", body);
    formData.append("date", new Date());
    formData.append("ticketType", ticketType);
    formData.append("priority", priority);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/ticket/add`,
        method: "post",
        withCredentials: true,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Ticket has been raised");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // request to array
  const requestToArr = [
    {
      title: "HR",
      value: "headHr",
    },
    {
      title: "Facility Team",
      value: "facilityTeam",
    },
    {
      title: "IT Helpdesk (System Admin)",
      value: "itHelpDesk",
    },
  ];

  // ticket type
  const ticketTypeArray = [
    {
      title: "Incident",
      value: "Incident",
    },
    {
      title: "New Request",
      value: "New Request",
    },
  ];

  useEffect(() => {
    getTickets();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">Tickets</h1>
          <div className="mt-5 w-full">
            {ticketData?.length === 0 ? (
              <div className="flex justify-center items-center flex-col gap-3">
                <p className="text-slate-500 font-medium text-center mt-5">
                  No ticket raised yet
                </p>
                <DialogBox
                  trigger={
                    <ButtonCompo variant={"contained"}>
                      Raise A Ticket
                    </ButtonCompo>
                  }
                  title="Raise A Ticket"
                  actionButton={
                    <ButtonCompo onClick={raiseTicket}>Raise</ButtonCompo>
                  }
                  closeActionButton={<ButtonCompo>cancel</ButtonCompo>}
                >
                  <div className="space-y-3">
                    <SelectField
                      label={"Request To"}
                      valueArray={requestToArr}
                      setValue={(event) => setRequestTo(event?.target?.value)}
                    />
                    <SelectField
                      label={"Ticket Type"}
                      valueArray={ticketTypeArray}
                      setValue={(event) => setTicketType(event?.target?.value)}
                    />
                    <section className="space-y-2 py-3 rounded-lg">
                      <p className="text-[15px] text-slate-700 font-medium">
                        Ticket Priority
                      </p>
                      <section className="flex justify-start items-center gap-3">
                        <ButtonCompo
                          onClick={() => setPriority("High")}
                          size={"small"}
                          variant={
                            priority === "High" ? "contained" : "outlined"
                          }
                          color={"error"}
                        >
                          High
                        </ButtonCompo>
                        <ButtonCompo
                          onClick={() => setPriority("Medium")}
                          size={"small"}
                          variant={
                            priority === "Medium" ? "contained" : "outlined"
                          }
                          color={"warning"}
                        >
                          Medium
                        </ButtonCompo>
                        <ButtonCompo
                          onClick={() => setPriority("Low")}
                          size={"small"}
                          variant={
                            priority === "Low" ? "contained" : "outlined"
                          }
                          color={"success"}
                        >
                          Low
                        </ButtonCompo>
                      </section>
                    </section>
                    <InputField
                      label="Subject"
                      onChange={(event) => setSubject(event?.target?.value)}
                    />
                    <InputField
                      label="Description"
                      multiline
                      onChange={(event) => setBody(event?.target?.value)}
                    />
                  </div>
                </DialogBox>
              </div>
            ) : (
              <div className="w-full mt-5">
                <div className="flex justify-end w-full mb-5">
                  <DialogBox
                    trigger={
                      <ButtonCompo variant={"contained"}>
                        Raise A Ticket
                      </ButtonCompo>
                    }
                    title="Raise A Ticket"
                    actionButton={
                      <ButtonCompo onClick={raiseTicket}>Raise</ButtonCompo>
                    }
                    closeActionButton={<ButtonCompo>cancel</ButtonCompo>}
                  >
                    <div className="space-y-3">
                      <SelectField
                        label={"Request To"}
                        valueArray={requestToArr}
                        setValue={(event) => setRequestTo(event?.target?.value)}
                      />
                      <SelectField
                        label={"Ticket Type"}
                        valueArray={ticketTypeArray}
                        setValue={(event) =>
                          setTicketType(event?.target?.value)
                        }
                      />
                      <section className="space-y-2 py-3 rounded-lg">
                        <p className="text-[15px] text-slate-700 font-medium">
                          Ticket Priority
                        </p>
                        <section className="flex justify-start items-center gap-3">
                          <ButtonCompo
                            onClick={() => setPriority("High")}
                            size={"small"}
                            variant={
                              priority === "High" ? "contained" : "outlined"
                            }
                            color={"error"}
                          >
                            High
                          </ButtonCompo>
                          <ButtonCompo
                            onClick={() => setPriority("Medium")}
                            size={"small"}
                            variant={
                              priority === "Medium" ? "contained" : "outlined"
                            }
                            color={"warning"}
                          >
                            Medium
                          </ButtonCompo>
                          <ButtonCompo
                            onClick={() => setPriority("Low")}
                            size={"small"}
                            variant={
                              priority === "Low" ? "contained" : "outlined"
                            }
                            color={"success"}
                          >
                            Low
                          </ButtonCompo>
                        </section>
                      </section>
                      <InputField
                        label="Subject"
                        onChange={(event) => setSubject(event?.target?.value)}
                      />
                      <InputField
                        label="Description"
                        multiline
                        onChange={(event) => setBody(event?.target?.value)}
                      />
                      <section>
                        <input
                          type="file"
                          multiple
                          className="hidden"
                          onChange={(event) =>
                            setTicketFiles(event.target.files)
                          }
                          ref={ticketFileRef}
                        />
                        <section
                          className=" flex flex-col gap-1 justify-center items-center border-slate-400/60 border py-3 rounded-md cursor-pointer"
                          onClick={() => ticketFileRef.current.click()}
                        >
                          <div className="flex justify-center items-center gap-2">
                            <MdCloudUpload
                              size={25}
                              className="text-blue-600"
                            />
                            <p className="text-blue-600">Upload Documents</p>
                          </div>
                          {ticketFiles.length > 5 ? (
                            <p className="text-[15px] text-red-500">
                              Maximum 5 files can be uploaded
                            </p>
                          ) : (
                            <p className="text-[15px] text-slate-500">
                              {ticketFiles.length === 0
                                ? "No files selected"
                                : `${ticketFiles.length} files selected`}
                            </p>
                          )}
                        </section>
                      </section>
                    </div>
                  </DialogBox>
                </div>
                <div className="overflow-auto">
                  <Table className="border">
                    <TableHead>
                      <TableRow className="bg-blue-500">
                        <TableCell
                          colSpan={1}
                          className="!text-center !text-white"
                        >
                          Ticket Number
                        </TableCell>
                        <TableCell
                          colSpan={1}
                          className="!text-center !text-white"
                        >
                          Priority
                        </TableCell>
                        <TableCell colSpan={2} className="!text-white">
                          Ticket
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Open
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Close
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Request To
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          Progress
                        </TableCell>
                        <TableCell
                          colSpan={3}
                          className="!text-center !text-white"
                        >
                          View
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ticketData?.map((e, i) => (
                        <>
                          <TableRow>
                            <TableCell colSpan={1} className="!text-center">
                              <span className="bg-blue-200/50 px-3 py-1 rounded-full font-medium text-[14px] text-blue-700">
                                {e?.ticketNumber}
                              </span>
                            </TableCell>
                            <TableCell colSpan={1} className="!text-center">
                              <Chip
                                label={e?.priority}
                                color={
                                  e?.priority === "High"
                                    ? "error"
                                    : e?.priority === "Medium"
                                    ? "warning"
                                    : "success"
                                }
                              />
                            </TableCell>
                            <TableCell colSpan={2}>
                              <div>
                                <div>
                                  <p className="font-medium">
                                    {e?.subject}{" "}
                                    {e?.status === true ? (
                                      <span className="ml-2 px-3 py-1 bg-green-200/70 text-green-700 rounded-full font-medium text-[13px]">
                                        Open
                                      </span>
                                    ) : (
                                      <span className="ml-2 px-3 py-1 bg-red-200/70 text-red-700 rounded-full font-medium text-[13px]">
                                        Closed
                                      </span>
                                    )}
                                    <span className="ml-2">
                                      <Chip label={e?.ticketType} />
                                    </span>
                                  </p>
                                  <p className="text-slate-500 mt-2 w-[0vw] lg:w-[30vw] truncate">
                                    {e?.body}
                                  </p>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {new Date(e?.openOn).toLocaleDateString("en-US", {
                                timeZone: "Asia/Kolkata",
                              })}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.closeOn === undefined
                                ? "--"
                                : new Date(e?.closeOn).toLocaleDateString(
                                    "en-US",
                                    {
                                      timeZone: "Asia/Kolkata",
                                    }
                                  )}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.requestTo === "headHr"
                                ? "HR"
                                : e?.requestTo === "itHelpDesk"
                                ? "IT Helpdesk (System Admin)"
                                : "Facility Team"}
                            </TableCell>
                            <TableCell colSpan={3} className="!text-center">
                              {e?.progress === "Raised" ? (
                                <span className="text-[13.8px] bg-slate-200 px-3 py-1 font-medium text-slate-700 rounded-full">
                                  Raised
                                </span>
                              ) : e?.progress === "In Progress" ? (
                                <span className="text-[13.8px] bg-yellow-200 px-3 py-1 font-medium text-yellow-700 rounded-full">
                                  In Progress
                                </span>
                              ) : e?.progress === "Resolved" ? (
                                <span className="text-[13.8px] bg-green-200 px-3 py-1 font-medium text-green-700 rounded-full">
                                  Resolved
                                </span>
                              ) : (
                                <span className="text-[13.8px] bg-red-200 px-3 py-1 font-medium text-red-700 rounded-full">
                                  Rejected
                                </span>
                              )}
                            </TableCell>
                            <TableCell className="!text-center">
                              <DialogBox
                                trigger={<ButtonCompo>View</ButtonCompo>}
                                maxWidth="sm"
                              >
                                <div>
                                  <div className="flex w-full justify-start items-center gap-[5rem]">
                                    <section>
                                      <p className="font-medium text-[15px]">
                                        Employee ID
                                      </p>
                                      <p className="text-slate-500 mt-1">
                                        {e?.employeeId}
                                      </p>
                                    </section>
                                    <section>
                                      <p className="font-medium text-[15px]">
                                        Raised By
                                      </p>
                                      <p className="text-slate-500 mt-1">
                                        {e?.employeeName}
                                      </p>
                                    </section>
                                    <section>
                                      <p className="font-medium text-[15px]">
                                        Role
                                      </p>
                                      <p className="text-slate-500 mt-1">
                                        {e?.employeeRole}
                                      </p>
                                    </section>
                                  </div>
                                  <div className="mt-5">
                                    <p className="font-medium">{e?.subject}</p>
                                    <p className="text-slate-500 mt-3">
                                      {e?.body}
                                    </p>
                                  </div>
                                  {e?.employeeDocs?.length > 0 ? (
                                    <div className="mt-5">
                                      <AccrodianBox title={"Your Documents"}>
                                        <div className="grid grid-cols-4 gap-3">
                                          {e?.employeeDocs?.map((data, i) => (
                                            <Link
                                              to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                              target="_blank"
                                            >
                                              <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                <IoDocumentText
                                                  size={45}
                                                  className="text-blue-500"
                                                />
                                                <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                  {data}
                                                </p>
                                              </section>
                                            </Link>
                                          ))}
                                        </div>
                                      </AccrodianBox>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {e?.adminDocs?.length > 0 ? (
                                    <div className="mt-5">
                                      <AccrodianBox title={"Reply Documents"}>
                                        <div className="grid grid-cols-4 gap-3">
                                          {e?.adminDocs?.map((data, i) => (
                                            <Link
                                              to={`${SERVER_URL}/api/v1/file/view/${data}`}
                                              target="_blank"
                                            >
                                              <section className="flex flex-col justify-center items-center border p-3 rounded-md hover:bg-blue-50/50">
                                                <IoDocumentText
                                                  size={45}
                                                  className="text-blue-500"
                                                />
                                                <p className="text-[15px] text-blue-600 font-medium truncate w-[6rem]">
                                                  {data}
                                                </p>
                                              </section>
                                            </Link>
                                          ))}
                                        </div>
                                      </AccrodianBox>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </DialogBox>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeTickets;
